import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES, SERVICE_IMAGES } from "../../data/site";

export const Services = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="py-24 md:py-32 bg-bone"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                {/* Header row */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16 reveal">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-moss mb-5">
                            <span className="h-px w-10 bg-moss inline-block align-middle mr-3" />
                            What We Do
                        </div>
                        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
                            Fifteen services. One crew that{" "}
                            <span className="text-copper">actually shows up.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-muted_ink leading-relaxed">
                        From flagship spray foam to varmint removal, we handle the entire building
                        envelope — not just the part everyone else wants to bid on.
                    </p>
                </div>

                {/* Bento grid: 12 cols, flagship spans 2 each */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
                    {SERVICES.map((s, idx) => {
                        const isFlagship = !!s.kicker;
                        const photo = SERVICE_IMAGES[s.id];
                        const span = isFlagship ? "lg:col-span-6" : "lg:col-span-4";
                        return (
                            <Link
                                key={s.id}
                                to={`/services/${s.id}`}
                                data-testid={`service-card-${s.id}`}
                                className={`reveal group bg-white border border-line p-7 md:p-9 flex flex-col justify-between min-h-[280px] hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden ${span}`}
                                style={{ transitionDelay: `${(idx % 6) * 60}ms` }}
                            >
                                {photo && (
                                    <>
                                        <img
                                            src={photo}
                                            alt={s.title}
                                            loading="lazy"
                                            className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-95 transition-opacity duration-500"
                                            style={{ filter: "brightness(1.15) contrast(1.05) saturate(1.1)" }}
                                        />
                                        {/* readability overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-white/75 to-white/40 group-hover:from-white/90 group-hover:via-white/55 group-hover:to-white/15 transition-all duration-500" />
                                        {isFlagship && (
                                            <div className="absolute top-5 right-5 z-20 text-[10px] tracking-[0.2em] uppercase font-bold text-copper bg-bone/90 px-2 py-1">
                                                {s.kicker}
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="relative z-10">
                                    <div className="flex items-start justify-between gap-4">
                                        <h3 className="font-heading text-2xl md:text-3xl font-bold tracking-tight">
                                            {s.title}
                                        </h3>
                                        <ArrowUpRight
                                            size={22}
                                            strokeWidth={1.5}
                                            className="text-ink opacity-50 group-hover:opacity-100 group-hover:text-copper group-hover:rotate-12 transition-all shrink-0"
                                        />
                                    </div>
                                    <p className="mt-3 text-sm md:text-base text-ink/80 leading-relaxed font-medium">
                                        {s.blurb}
                                    </p>
                                    {s.details && (
                                        <p className="mt-4 text-sm text-muted_ink leading-relaxed border-l-2 border-copper/40 pl-4 line-clamp-4">
                                            {s.details}
                                        </p>
                                    )}
                                </div>
                                {s.bullets && (
                                    <ul className="relative z-10 mt-6 flex flex-wrap gap-2">
                                        {s.bullets.map((b) => (
                                            <li
                                                key={b}
                                                className="text-[11px] tracking-wider uppercase font-bold border border-line px-3 py-1.5 bg-bone"
                                            >
                                                {b}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
